var _circle, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoInternetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#E2E6F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0623 23.2038C35.4475 22.8502 33.7693 22.6733 32.0277 22.6733C28.8265 22.6733 25.8395 23.2707 23.0666 24.4656C20.4482 25.5938 18.1414 27.1342 16.1461 29.0866C15.9503 29.2783 15.9523 29.5924 16.1461 29.7862L18.2834 31.9235C18.4786 32.1187 18.7946 32.1183 18.9949 31.9283C20.6485 30.359 22.5413 29.1172 24.6735 28.2028C26.9612 27.2217 29.4126 26.7312 32.0277 26.7312C32.8641 26.7315 33.6838 26.7818 34.4867 26.8822L37.0623 23.2038ZM31.7494 30.7915C29.7814 30.8256 27.9412 31.2139 26.229 31.9563C24.5936 32.6655 23.1506 33.6046 21.9002 34.7739C21.7001 34.9609 21.6989 35.275 21.8902 35.4709L24.0319 37.6636C24.2265 37.8628 24.5455 37.8637 24.7512 37.676C25.6569 36.8491 26.6847 36.1879 27.8346 35.6922C28.0537 35.5978 28.2754 35.5112 28.4996 35.4326L31.7494 30.7915ZM32.8521 34.8764L35.4437 31.1751C36.2643 31.3684 37.0589 31.6342 37.8277 31.9726C39.4639 32.6927 40.9071 33.6477 42.1572 34.8373C42.356 35.0265 42.354 35.3414 42.16 35.5355L40.0235 37.6719C39.8282 37.8672 39.5124 37.8663 39.3086 37.68C38.4017 36.8512 37.3725 36.1887 36.2208 35.6922C35.1575 35.2339 34.0346 34.962 32.8521 34.8764ZM37.9135 27.6479L40.3313 24.195C40.5517 24.2815 40.7709 24.3717 40.9887 24.4656C43.6072 25.5938 45.914 27.1342 47.9092 29.0866C48.1051 29.2783 48.1031 29.5924 47.9093 29.7862L45.7721 31.9233C45.5768 32.1186 45.2607 32.1181 45.0605 31.9279C43.4077 30.358 41.5153 29.1163 39.3832 28.2028C38.9006 27.9961 38.4107 27.8111 37.9135 27.6479ZM29.6268 44.6871C30.2806 45.3409 31.0809 45.6678 32.0277 45.6678C32.9745 45.6678 33.7748 45.3409 34.4286 44.6871C35.0823 44.0334 35.4092 43.2331 35.4092 42.2862C35.4092 41.3394 35.0823 40.5391 34.4286 39.8853C33.7748 39.2316 32.9745 38.9047 32.0277 38.9047C31.0809 38.9047 30.2806 39.2316 29.6268 39.8853C28.973 40.5391 28.6462 41.3394 28.6462 42.2862C28.6462 43.2331 28.973 44.0334 29.6268 44.6871Z",
    fill: "#BFB0DE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.9033,
    y: 19,
    width: 1.66859,
    height: 30.1854,
    transform: "rotate(35 39.9033 19)",
    fill: "#BFB0DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInternetIcon);
export default __webpack_public_path__ + "static/media/no-internet-icon.93692730c5d38e3b088f23f2a230703e.svg";
export { ForwardRef as ReactComponent };